/**
 * A server-sent event stream, decoded. The browser has `EventSource` for this
 * and it cannot be used here: it sends no `Authorization` header, and the only
 * way to authenticate one is to put the token in the query string, where it
 * lands in every access log and proxy trace between here and the server. See
 * docs/DECISIONS/0022.
 */
/**
 * Bytes arrive in whatever sizes the network chose, so a chunk may hold half
 * an event, several, or part of a single line. The parser holds what it cannot
 * yet complete and emits only whole events.
 */
export function createEventParser(emit) {
    let buffer = "";
    return (chunk) => {
        // A server or a proxy may use CRLF. Normalising once here means the rest
        // of this file only has to know about one line ending.
        buffer += chunk.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
        let boundary = buffer.indexOf("\n\n");
        while (boundary !== -1) {
            const block = buffer.slice(0, boundary);
            buffer = buffer.slice(boundary + 2);
            const event = parseBlock(block);
            if (event !== null)
                emit(event);
            boundary = buffer.indexOf("\n\n");
        }
    };
}
function parseBlock(block) {
    let event = "message";
    const data = [];
    for (const line of block.split("\n")) {
        // A comment. The heartbeat that keeps a proxy from closing an idle
        // connection is one of these, and it carries nothing to act on.
        if (line.startsWith(":"))
            continue;
        const colon = line.indexOf(":");
        const field = colon === -1 ? line : line.slice(0, colon);
        // One optional space after the colon belongs to the format, not the value.
        const rest = colon === -1 ? "" : line.slice(colon + 1).replace(/^ /, "");
        if (field === "event")
            event = rest;
        else if (field === "data")
            data.push(rest);
    }
    return data.length === 0 ? null : { event, data: data.join("\n") };
}
//# sourceMappingURL=sse.js.map